import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=3174f83f&"
import script from "./InventoryTable.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3174f83f')) {
      api.createRecord('3174f83f', component.options)
    } else {
      api.reload('3174f83f', component.options)
    }
    module.hot.accept("./InventoryTable.vue?vue&type=template&id=3174f83f&", function () {
      api.rerender('3174f83f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/reports/InventoryTable.vue"
export default component.exports